import { createAction, props } from '@ngrx/store';
import {
  BreakRuleRequest,
  BreakRuleWithUsageListItemResponse,
  DutyModelRequest,
  DutyModelWithAdoptingDepartmentsListItemResponse,
  RoundingRuleRequest,
  RoundingRuleWithUsageListItemResponse,
} from '../../../api';

// Duty models
export const loadDutyModels = createAction(
  '[Location Working Time] Load duty models',
  props<{ payload: { location: number } }>()
);
export const setDutyModels = createAction(
  '[Location Working Time] Set duty models',
  props<{ payload: DutyModelWithAdoptingDepartmentsListItemResponse[] }>()
);
export const successDutyModels = createAction('[Location Working Time] Success duty models');
export const errorDutyModels = createAction('[Location Working Time] Error duty models');
export const resetDutyModels = createAction('[Location Working Time] Reset duty models');

// Create / update / delete duty model
export const createDutyModel = createAction(
  '[Location Working Time] Create duty model',
  props<{ payload: { location: number; body: DutyModelRequest } }>()
);
export const updateDutyModel = createAction(
  '[Location Working Time] Update duty model',
  props<{ payload: { location: number; dutyModel: number; body: DutyModelRequest } }>()
);
export const deleteDutyModel = createAction(
  '[Location Working Time] Delete duty model',
  props<{ payload: { location: number; dutyModel: number } }>()
);
export const setDutyModelActivation = createAction(
  '[Location Working Time] Set duty model activation',
  props<{ payload: { location: number; dutyModel: number; active: boolean } }>()
);
export const successDutyModelCrud = createAction('[Location Working Time] Success duty model crud');
/** `errors` is the field map of a 400 on create / update (e.g. a duplicate `shortCode`), shown at the form field. */
export const errorDutyModelCrud = createAction(
  '[Location Working Time] Error duty model crud',
  props<{ errors?: Record<string, string[]> }>()
);

// Break rules
export const loadBreakRules = createAction(
  '[Location Working Time] Load break rules',
  props<{ payload: { location: number } }>()
);
export const setBreakRules = createAction(
  '[Location Working Time] Set break rules',
  props<{ payload: BreakRuleWithUsageListItemResponse[] }>()
);
export const successBreakRules = createAction('[Location Working Time] Success break rules');
export const errorBreakRules = createAction('[Location Working Time] Error break rules');
export const resetBreakRules = createAction('[Location Working Time] Reset break rules');

// Create / update / delete break rule
export const createBreakRule = createAction(
  '[Location Working Time] Create break rule',
  props<{ payload: { location: number; body: BreakRuleRequest } }>()
);
export const updateBreakRule = createAction(
  '[Location Working Time] Update break rule',
  props<{ payload: { location: number; breakRule: number; body: BreakRuleRequest } }>()
);
export const deleteBreakRule = createAction(
  '[Location Working Time] Delete break rule',
  props<{ payload: { location: number; breakRule: number } }>()
);
export const setBreakRuleActivation = createAction(
  '[Location Working Time] Set break rule activation',
  props<{ payload: { location: number; breakRule: number; active: boolean } }>()
);
export const successBreakRuleCrud = createAction('[Location Working Time] Success break rule crud');
export const errorBreakRuleCrud = createAction('[Location Working Time] Error break rule crud');

// Rounding rules
export const loadRoundingRules = createAction(
  '[Location Working Time] Load rounding rules',
  props<{ payload: { location: number } }>()
);
export const setRoundingRules = createAction(
  '[Location Working Time] Set rounding rules',
  props<{ payload: RoundingRuleWithUsageListItemResponse[] }>()
);
export const successRoundingRules = createAction('[Location Working Time] Success rounding rules');
export const errorRoundingRules = createAction('[Location Working Time] Error rounding rules');
export const resetRoundingRules = createAction('[Location Working Time] Reset rounding rules');

// Create / update / delete rounding rule
export const createRoundingRule = createAction(
  '[Location Working Time] Create rounding rule',
  props<{ payload: { location: number; body: RoundingRuleRequest } }>()
);
export const updateRoundingRule = createAction(
  '[Location Working Time] Update rounding rule',
  props<{ payload: { location: number; roundingRule: number; body: RoundingRuleRequest } }>()
);
export const deleteRoundingRule = createAction(
  '[Location Working Time] Delete rounding rule',
  props<{ payload: { location: number; roundingRule: number } }>()
);
export const setRoundingRuleActivation = createAction(
  '[Location Working Time] Set rounding rule activation',
  props<{ payload: { location: number; roundingRule: number; active: boolean } }>()
);
export const successRoundingRuleCrud = createAction('[Location Working Time] Success rounding rule crud');
export const errorRoundingRuleCrud = createAction('[Location Working Time] Error rounding rule crud');
